import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import Placeholder from '@atlassian/jira-placeholder';
import { TEAM_NAME, WIDGET_ID, PACKAGE_NAME } from '../constants';
import { type WidgetProps, Widget } from './main';

export const WidgetWithErrorBoundary = ({ queryReference }: WidgetProps) => (
	<JSErrorBoundary
		id={WIDGET_ID}
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
		fallback="unmount"
	>
		<Placeholder name="jira-home-broadcast-widget" fallback={null}>
			<Widget queryReference={queryReference} />
		</Placeholder>
	</JSErrorBoundary>
);
